<template>
  <div id="pageRoot">
    <img id="bg" src="/pages/img/sordocas/svgCas14bg.svg" />

    <img
      id="castle"
      class="pageElement basicItem01"
      src="/pages/img/sordocas/svgCas14Castle.svg"
    />
    <img
      id="pearl"
      class="pageElement basicItem01"
      src="/pages/img/sordocas/svgCas14Pearl.svg"
    />
    <img
      id="key"
      class="pageElement basicItem01"
      src="/pages/img/sordocas/svgCas14Key.svg"
    />

    <span class="normalTheme pageInstruction" style="left: 87px; top: 82px">
      <p>Señala en cada renglón la palabra del cuento que aparece dibujada.</p>
    </span>

    <div id="radio1">
      <label class="toggleButtonContainer pageElement" id="toggle11"
        >PESAS
        <input
          type="radio"
          name="pesas"
          ref="1-1"
          v-on:change="saveOption('radios', 1, 1)"
          :onload="loadOption('radios', 1, 1)"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle12"
        >PERAS
        <input
          type="radio"
          name="pesas"
          ref="1-2"
          v-on:change="saveOption('radios', 1, 2)"
          :onload="loadOption('radios', 1, 2)"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle13"
        >PERLAS
        <input
          type="radio"
          name="pesas"
          ref="1-3"
          v-on:change="saveOption('radios', 1, 3)"
          :onload="loadOption('radios', 1, 3)"
        />
        <span class="toggleButton"></span>
      </label>
    </div>

    <div id="radio2">
      <label class="toggleButtonContainer pageElement" id="toggle21"
        >LLAMAR
        <input
          type="radio"
          name="llamar"
          ref="2-1"
          v-on:change="saveOption('radios', 2, 1)"
          :onload="loadOption('radios', 2, 1)"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle22"
        >LLEGAR
        <input
          type="radio"
          name="llamar"
          ref="2-2"
          v-on:change="saveOption('radios', 2, 2)"
          :onload="loadOption('radios', 2, 2)"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle23"
        >LLAVE
        <input
          type="radio"
          name="llamar"
          ref="2-3"
          v-on:change="saveOption('radios', 2, 3)"
          :onload="loadOption('radios', 2, 3)"
        />
        <span class="toggleButton"></span>
      </label>
    </div>

    <div
      class="textBubble"
      style="width: 377px; height: 253px; left: 541px; margin-top: 410px"
    >
      <div
        class="textContainer textBase center"
        style="width: 90%; height: 90%"
      >
        <p class="center">
          ¡Presta atención!<br />
          <br />
          Las palabras son muy similares y las puedes confundir.
        </p>
      </div>
      <img
        class="arrow"
        src="/pages/img/general/textBubbleArrowLeft.svg"
        style="top: 245px; left: 210px"
      />
    </div>
    <!--- FOOTER --->
    <span class="footer-page footer-read"></span>
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 223px;
  top: 192px;
}
#castle {
  position: absolute;
  left: 62px;
  top: 135px;
}
#pearl {
  position: absolute;
  left: 554px;
  top: 189px;
}
#key {
  position: absolute;
  left: 32px;
  top: 491px;
}
#toggle11 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 710px;
  top: 186px;
}
#toggle12 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 710px;
  top: 240px;
}
#toggle13 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 710px;
  top: 293px;
}
#toggle21 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 223px;
  top: 497px;
}
#toggle22 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 223px;
  top: 551px;
}
#toggle23 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 223px;
  top: 604px;
}
.textBubble p {
  font-size: 30px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "cas/Video 29.mp4",
        "cas/Video 30c.mp4",
        "cas/Video 31.mp4",
        "cas/Video 32.mp4",
        "cas/Video 33.mp4",
        "cas/Video 34.mp4",
      ],
    };
  },
  methods: {
    dbId(name, group) {
      return `${this.$parent.pageID()}-${name}-${group}`;
    },
    async loadOption(name, group, option) {
      var id = this.dbId(name, group);

      var value = await this.$db.options
        .get({
          id: id,
        })
        .catch(function (error) {
          console.log("error getting option" + error);
        });
      if (value === undefined) return;
      console.log(value);

      this.$refs[group + "-" + option].checked = value.option == option;

      console.log(
        "option loaded: " +
          id +
          ", option:" +
          option +
          ", selected:" +
          value.option
      );
    },
    saveOption(name, group, option) {
      var id = this.dbId(name, group);

      this.$db.options
        .put({
          id: id,
          option: option,
        })
        .catch(function (error) {
          console.log("error saving option" + error);
        });

      console.log("option saved: " + id + ", " + option);
    },
  },
};
</script>